export const All = {
  zero: "0rem",
  "4xs": "0.125rem",
  "3xs": "0.25rem",
  "2xs": "0.5rem",
  xs: "0.75rem",
  sm: "1rem",
  md: "1.5rem",
  lg: "2rem",
  xl: "3rem",
  "2xl": "4rem",
  "3xl": "6rem",
};

export const Global = {
  inherit: "inherit",
  initial: "initial",
  revert: "revert",
  revertLayer: "revert-layer",
  unset: "unset",
};

export const Vertical = {
  zero: "0rem",
  "4xs": "0.125rem 0",
  "3xs": "0.25rem 0",
  "2xs": "0.5rem 0",
  xs: "0.75rem 0",
  sm: "1rem 0",
  md: "1.5rem 0",
  lg: "2rem 0",
  xl: "3rem 0",
  "2xl": "4rem 0",
  "3xl": "6rem 0",
};

export const Horizontal = {
  zero: "0rem",
  "4xs": "0 0.125rem",
  "3xs": "0 0.25rem",
  "2xs": "0 0.5rem",
  xs: "0 0.75rem",
  sm: "0 1rem",
  md: "0 1.5rem",
  lg: "0 2rem",
  xl: "0 3rem",
  "2xl": "0 4rem",
  "3xl": "0 6rem",
};

export const Top = {
  zero: "0rem",
  "4xs": "0.125rem 0 0 0",
  "3xs": "0.25rem 0 0 0",
  "2xs": "0.5rem 0 0 0",
  xs: "0.75rem 0 0 0",
  sm: "1rem 0 0 0",
  md: "1.5rem 0 0 0",
  lg: "2rem 0 0 0",
  xl: "3rem 0 0 0",
  "2xl": "4rem 0 0 0",
  "3xl": "6rem 0 0 0",
};

export const Right = {
  zero: "0rem",
  "4xs": "0 0.125rem 0 0",
  "3xs": "0 0.25rem 0 0",
  "2xs": "0 0.5rem 0 0",
  xs: "0 0.75rem 0 0",
  sm: "0 1rem 0 0",
  md: "0 1.5rem 0 0",
  lg: "0 2rem 0 0",
  xl: "0 3rem 0 0",
  "2xl": "0 4rem 0 0",
  "3xl": "0 6rem 0 0",
};

export const Bottom = {
  zero: "0rem",
  "4xs": "0 0 0.125rem 0",
  "3xs": "0 0 0.25rem 0",
  "2xs": "0 0 0.5rem 0",
  xs: "0 0 0.75rem 0",
  sm: "0 0 1rem 0",
  md: "0 0 1.5rem 0",
  lg: "0 0 2rem 0",
  xl: "0 0 3rem 0",
  "2xl": "0 0 4rem 0",
  "3xl": "0 0 6rem 0",
};

export const Left = {
  zero: "0rem",
  "4xs": "0 0 0 0.125rem",
  "3xs": "0 0 0 0.25rem",
  "2xs": "0 0 0 0.5rem",
  xs: "0 0 0 0.75rem",
  sm: "0 0 0 1rem",
  md: "0 0 0 1.5rem",
  lg: "0 0 0 2rem",
  xl: "0 0 0 3rem",
  "2xl": "0 0 0 4rem",
  "3xl": "0 0 0 6rem",
};

export const Padding = {
  Global,
  All,
  Vertical,
  Horizontal,
  Top,
  Right,
  Bottom,
  Left,
};
